import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const RecordingIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 8.00031C14.1663 4.59466 11.4059 1.83349 8.00032 1.83331C4.59456 1.83331 1.83333 4.59455 1.83333 8.00031C1.8335 11.4059 4.59467 14.1663 8.00032 14.1663C11.4058 14.1661 14.1662 11.4058 14.1663 8.00031ZM15.1663 8.00031C15.1662 11.9581 11.9581 15.1661 8.00032 15.1663C4.04239 15.1663 0.833504 11.9582 0.833328 8.00031C0.833328 4.04226 4.04228 0.833313 8.00032 0.833313C11.9582 0.833489 15.1663 4.04237 15.1663 8.00031Z"
      fill="currentColor"
    />
    <path
      d="M11.1663 8.00031C11.1662 9.74895 9.74896 11.1661 8.00032 11.1663C6.25153 11.1663 4.8335 9.74906 4.83333 8.00031C4.83333 6.2514 6.25142 4.83331 8.00032 4.83331C9.74907 4.83349 11.1663 6.25151 11.1663 8.00031Z"
      fill="currentColor"
    />
  </svg>
);
